document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.getElementsByClassName("keen-slider");
    [...sliders].forEach(function (slider) {
      const sliderId = slider.id;
      const sliderElement = document.getElementById(sliderId);
      const prevButton = sliderElement.querySelector(".arrow.arrow--left");
      const nextButton = sliderElement.querySelector(".arrow.arrow--right");
      const autoplaySpeed = parseInt(sliderElement.getAttribute("data-autoplay-speed")) * 1000;
  
      let {
        view_desktop_large,
        view_desktop,
        viewTablet,
        viewMobile,
        customClass,
        spacingDesktopLarge,
        spacingDesktop,
        spacingMobile,
        spacingTablet,
      } = sliderElement.dataset;
  
      const sliderContent = sliderElement.querySelector(".slider-content");
      const SliderVideoWrapper = sliderContent.querySelectorAll("video");
      sliderElement.parentNode.classList.add(customClass);
      sliderContent.removeAttribute("loading");
  
      let keenSlider;
      let currentSlider = 0;
  
      let autoplay = sliderElement.dataset.autoplay === "true";
      let centerMode = sliderElement.dataset.centerMode === "true";
      let breakpointAuto = sliderElement.dataset.breakpointsAuto === "true";
      let enableCenterMode;
  
      centerMode ? (enableCenterMode = "center") : "";
  
      if (customClass == "collections_slider") viewMobile = "auto";
      if (customClass == "collections_slider") viewTablet = "auto";
      
      if (viewMobile == 1) viewMobile = "auto";
      view_desktop_large == 1 ? (view_desktop_large = "auto") : "";
      view_desktop == 1 ? (view_desktop = "auto") : "";
  
      
      if(breakpointAuto){
        viewTablet == 1 ?  (viewTablet = "auto") : "";
        viewMobile == 1 ?  (viewMobile = "auto") : "";
      }
  
      const breakpoints = {
        "(min-width: 0px)": {
          renderMode: "performance",
          slides: {
            perView: viewMobile,
            spacing: spacingMobile,
            origin: enableCenterMode,
          },
        },
        "(min-width: 580px)": {
          slides: {
            perView: viewTablet,
            spacing: spacingTablet,
            origin: enableCenterMode,
          },
        },
        "(min-width: 1200px)": {
          slides: {
            perView: view_desktop,
            spacing: spacingDesktop,
            origin: enableCenterMode,
          },
        },
        "(min-width: 1380px)": {
          slides: {
            perView: view_desktop_large,
            spacing: spacingDesktopLarge,
            origin: enableCenterMode,
          },
        },
      };
  
      const initializeSlider = function () {
        keenSlider = new KeenSlider(sliderElement, {
          loop: true,
          duration: 1000,
          mode: "free-snap",
          dragSpeed: 0.5,
          dragStart: function () {
            sliderElement.classList.add("slider--dragging");
          },
          dragEnd: function () {
            sliderElement.classList.remove("slider--dragging");
          },
          breakpoints: breakpoints,
          slideChanged: function (s) {
            const currentSlide = s.track.details.rel;
  
            const videos = sliderElement.querySelectorAll(".video-player");
            videos.forEach((slide) => slide.classList.remove("active"));
            if (currentSlide !== undefined && currentSlide !== null) {
              videos[currentSlide]?.classList.add("active");
            }
          },
        });
  
        prevButton?.addEventListener("click", function () {
          keenSlider.prev();
        });
  
        nextButton?.addEventListener("click", function () {
          keenSlider.next();
        });
  
        if (autoplay) {
          startAutoplay(sliderElement);
        }
      };
  
      const startAutoplay = function (element) {
        if (autoplaySpeed > 0 && element) {
          keenSlider.interval = setInterval(function () {
            keenSlider.next();
          }, autoplaySpeed);
        }
      };
  
      const stopAutoplay = function () {
        if (keenSlider.interval) {
          clearInterval(keenSlider.interval);
        }
      };
  
      initializeSlider();
  
      sliderElement.addEventListener("mouseover", function () {
        stopAutoplay();
      });
  
      sliderElement.addEventListener("mouseout", function () {
        autoplay ? startAutoplay() : "";
      });
  
      // Video events
      SliderVideoWrapper?.forEach((video, index) => {
        const btnPlay = video.parentElement.querySelector('.play-button');
        const muteButton = video.parentElement.querySelector('.mute-button');
        const progressBar = video.parentElement.querySelector('.progress');
  
        video.parentElement.addEventListener("mouseenter", function () {
          const sourceTag = video.querySelector("source[data-src]");
          if (sourceTag && !sourceTag.getAttribute("src")) {
            const videoSrc = sourceTag.getAttribute("data-src");
            sourceTag.setAttribute("src", videoSrc);
            video.load();
          }
        });
  
        const clickHandler = (e) => {
          e.preventDefault();
  
          // if (
          //   navigator.userAgent.includes("Mac") ||
          //   navigator.userAgent.includes("iPhone")
          // ) {
          //   btnPlay.remove();
          // }
  
          if (!video.paused) {
            video.pause();
            video.parentNode.classList.remove("play");
            btnPlay.classList.remove("paused");
            startAutoplay(sliderElement);
            progressBar.style.display = 'none';
            return;
          } else {
            progressBar.style.display = 'block';
          }
  
          // Pausa todos los videos si el video actual está pausado.
          SliderVideoWrapper.forEach((v) => {
            v.pause();
            v.parentNode.classList.remove("play");
            const associatedBtnPlay = v
              .closest(".keen-slider__slide")
              .querySelector(".play-button");
            if (associatedBtnPlay) {
              associatedBtnPlay.classList.remove("paused");
            }
          });
          video.play();
          video.parentNode.classList.add("play");
          btnPlay.classList.add("paused");
          stopAutoplay();
        };
  
        btnPlay.addEventListener("click", clickHandler);
        // BgBtnPlay.addEventListener("click", clickHandler);
        video.addEventListener("click", clickHandler);
  
        muteButton.addEventListener('click', () => {
          muteButton.classList.toggle('muted');
          video.muted = !video.muted;
          // muteButton.textContent = video.muted ? 'Unmute' : 'Mute';
        });
  
        video.addEventListener('timeupdate', () => {
          const currentTime = video.currentTime;
          const duration = video.duration;
          const progressPercentage = (currentTime / duration) * 100;
          progressBar.style.width = `${progressPercentage}%`;
        });
  
        // Lógica para reproducir el siguiente video automáticamente.
        video.addEventListener("ended", () => {
          progressBar.style.width = "0";
          const nextIndex = (index + 1) % SliderVideoWrapper.length; // Obtener el índice del próximo video
          const nextVideo = SliderVideoWrapper[nextIndex];
          const nextBtnPlay = nextVideo
            .closest(".keen-slider__slide")
            .querySelector(".play-button");
  
          // Update the src attribute of the next video's source
          const nextSourceTag = nextVideo.querySelector("source[data-src]");
          if (nextSourceTag) {
            const nextVideoSrc = nextSourceTag.getAttribute("data-src");
            nextSourceTag.setAttribute("src", nextVideoSrc);
            nextVideo.load();
          }
  
          SliderVideoWrapper.forEach((v) => {
            v.pause();
            v.parentNode.classList.remove("play");
            const associatedBtnPlay = v
              .closest(".keen-slider__slide")
              .querySelector(".play-button");
            if (associatedBtnPlay) {
              associatedBtnPlay.classList.remove("paused");
            }
          });
  
          progressBar.style.display = 'block';
          nextVideo.play();
          nextVideo.parentNode.classList.add("play");
          if (nextBtnPlay) {
            nextBtnPlay.classList.add("paused");
          }
          stopAutoplay();
  
          keenSlider.moveToIdx(nextIndex);
        });
      });
    });
  });
  